import {
    Box,
    Grid,
} from "@chakra-ui/react";

import CompleteProfileForm from "./components/CompleteProfileForm";
import LoginShowcase from "../Login/components/LoginShowcase";

const CompleteProfile = () => {
    return (
        <Box
            minH="100vh"
            bg="#F8FAFC"
        >
            <Grid
                minH={{
                    base: "auto",
                    lg: "100vh",
                }}
                templateColumns={{
                    base: "1fr",
                    lg: "1fr 1fr",
                }}
            >
                <CompleteProfileForm />

                <Box
                    order={{
                        base: 2,
                        lg: 0,
                    }}
                    minH={{
                        base: "400px",
                        lg: "100vh",
                    }}
                >
                    <LoginShowcase />
                </Box>
            </Grid>
        </Box>
    );
};

export default CompleteProfile;